import React from 'react'
import * as Icon from 'react-feather';
const Checkbox = props => {
    return (
        <label className="checkbox">
            <input type="checkbox"  name={props.name} value={props.value} {...props} checked={props.checked} />            
            <span><small><Icon.Check className="w-4" /></small><i   dangerouslySetInnerHTML={{ __html: props.label }}></i></span>
        </label>
    )
}



export default Checkbox
